import request from '@/utils/request';

const groupCompany = {
  // 集团公司-装企搜索
  companySelect(query) {
    let URL = "";
    if (query.keyword) {
      URL = `cp/v1/group/company/select?keyword=${query.keyword}`;
    } else {
      URL = "cp/v1/group/company/select?keyword=''";
    }
    return request({
      url: URL,
      method: 'get',
    });
  },
  // 子公司列表
  grounpSubList() {
    return request({
      url: `cp/v1/group/sub/list`,
      method: 'get',
    });
  },
  // 绑定 sub_company_id;sms_code
  bindSubGroup(data) {
    return request({
      url: `cp/v1/group/sub/bind`,
      method: 'POST',
      data
    });
  },
  // 解绑sub_company_id
  removeSubGroup(data) {
    return request({
      url: `cp/v1/group/sub/remove`,
      method: 'POST',
      data
    });
  },
  // 发送短信验证码sub_company_id/geetest_validate
  groupSendsms(data) {
    return request({
      url: `cp/v1/group/bind/sendsms`,
      method: 'POST',
      data
    });
  },
  // 集团公司-切换登录公司to_company_id
  switchGroup(data) {
    return request({
      url: `cp/v1/group/switch`,
      method: 'POST',
      data
    });
  },
  // 导出
  exportGroup(query) {
    return request({
      url: `cp/v1/order/export_group`,
      method:'get',
      params:query
    });
  },
  
};


export default groupCompany;
